__turbopack_context__.v({
  "close": "_3jWm5G_close",
  "dialogButtons": "_3jWm5G_dialogButtons",
  "htmlDialog": "_3jWm5G_htmlDialog",
});
